var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { roundDecimal } from '../utils';
import { DEFAULT_NOTCHES, getNotches } from '../config';
import { formatCurrency } from '../formatCurrency';
export function _compactNumber(input, maxPrecision, notches) {
  if (maxPrecision === void 0) {
    maxPrecision = 1;
  }
  if (notches === void 0) {
    notches = DEFAULT_NOTCHES;
  }
  var parsedNumber = parseFloat(String(input));
  if (isFinite(parsedNumber) && notches && notches.length && parsedNumber >= notches[notches.length - 1].notch) {
    for (var i = notches.length; i--;) {
      var _a = notches[i],
        notch = _a.notch,
        unit = _a.unit;
      var nextNotch = notches[i - 1];
      var number = parseFloat(roundDecimal(parsedNumber / notch, maxPrecision));
      if (!nextNotch || Math.abs(number) < nextNotch.notch / notch) {
        return {
          number: number,
          unit: unit
        };
      }
    }
  }
  return {
    number: parseFloat(roundDecimal(parsedNumber, maxPrecision)),
    unit: ''
  };
}
export function compactCurrency(code, input, options, notches, language) {
  var maxPrecision = options && typeof options === 'object' ? options.maxPrecision : options;
  var _a = _compactNumber(input, maxPrecision, notches || getNotches(code, language)),
    number = _a.number,
    unit = _a.unit;
  var formatedCurrency = formatCurrency(code, number, options && typeof options === 'object' ? __assign(__assign({}, options), {
    precision: options.precision != null ? options.precision : false
  }) : {
    precision: false,
    maxPrecision: maxPrecision
  });
  return "" + formatedCurrency + unit;
}
export function compactNumber(input, maxPrecision, notches) {
  if (maxPrecision === void 0) {
    maxPrecision = 1;
  }
  if (notches === void 0) {
    notches = DEFAULT_NOTCHES;
  }
  var _a = _compactNumber(input, maxPrecision, notches),
    number = _a.number,
    unit = _a.unit;
  return "" + number + unit;
}
export function localizeCompactNumber(country, input, options, language) {
  var notches = getNotches(country, language);
  return compactCurrency(country, input, options && typeof options === 'object' ? __assign(__assign({}, options), {
    symbol: ''
  }) : {
    maxPrecision: options,
    symbol: ''
  }, notches);
}